import { Turnstile, TurnstileInstance, TurnstileProps } from '@marsidev/react-turnstile'
import { forwardRef } from 'react'

const TurnstileWidget = forwardRef<TurnstileInstance, Omit<TurnstileProps, 'siteKey'>>((props, ref): JSX.Element => (
	<Turnstile ref={ref} siteKey={process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY!} {...props} />
))

export default TurnstileWidget
